/**
 * Compatibility shim: replaces next/link with React Router's Link.
 * Existing pages can import from 'next/link' and Vite alias resolves here.
 */
import { Link as RouterLink } from 'react-router-dom';
import { forwardRef, type AnchorHTMLAttributes } from 'react';

interface NextLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  prefetch?: boolean;
  replace?: boolean;
  scroll?: boolean;
  shallow?: boolean;
  passHref?: boolean;
  legacyBehavior?: boolean;
}

const Link = forwardRef<HTMLAnchorElement, NextLinkProps>(
  ({ href, replace, children, prefetch, scroll, shallow, passHref, legacyBehavior, ...rest }, ref) => {
    return (
      <RouterLink to={href} replace={replace} ref={ref} {...rest}>
        {children}
      </RouterLink>
    );
  }
);

Link.displayName = 'Link';

export default Link;
